<template>
	<div class="row">
		<div class="col-sm-4">
			<select v-model="graveyard_id" class="form-control">
				<option :value="0">Alle Friedhöfe</option>
				<option v-for="graveyard in $store.getters.models('graveyards')" :value="graveyard.id">{{ graveyard.name }}</option>
			</select>
			<br>
		</div>
	</div>
</template>

<script>
import store from 'root/store.js'

export default {
	data () {
		return {
			_graveyard_id: 0,
			_graveyards: []
		}
	},

	activated () {
		this.$store.dispatch('graveyard')
	},

	computed: {
		graveyard_id: {
			get() {
				return store.getters.graveyard_id
			},

			set(aID) {
				if (typeof aID === "undefined") {
					return
				}

				console.log("Set ID: Component", aID)
				store.commit('graveyard_id', aID)
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// graveyard-select.vue?7bed9503